/**
 * CR 积分换算核心(spec 2026-10-16_cr-points-system-spec §五 A1)——**全站唯一换算点**。
 * 纪律:CR 只存在于展示与录入两端;一切存储/接口/预算均为 USD。
 * - 汇率是政策常数(写 Terms),调整=公开换价事件
 * - 精度:存储 decimal(18,8) → CR 理论 6 位小数,展示最多 3 位
 * - 舍入:half-up 只发生在显示层,存储/结算/接口永不取整
 * - 定价录入 CR 原生:crToUsdString 提交前转 USD decimal 字符串
 */
export const CR_PER_USD = 100;

export function toCr(usd: string | number): number {
  return parseFloat(String(usd)) * CR_PER_USD;
}

export interface FormatCrOptions {
  /** Intl locale,缺省交给运行时(Intl.NumberFormat 无参构造用宿主 locale) */
  locale?: string;
}

/** USD → CR 展示字符串:≤3 位小数,尾零自然修剪,halfExpand 舍入。 */
export function formatCr(usd: string | number, opts?: FormatCrOptions): string {
  // roundingMode 是 ES2023 Intl 字段,项目 TS lib 未含其类型,运行时(Node 22/现代浏览器)已支持
  const intlOptions = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
    roundingMode: 'halfExpand',
  } as Intl.NumberFormatOptions;
  const formatter = new Intl.NumberFormat(opts?.locale ?? undefined, intlOptions);
  return formatter.format(toCr(usd));
}

/** CR 输入 → USD decimal 字符串(4 位小数,兼容后端 zod ^\d+(\.\d{1,4})?$)。 */
export function crToUsdString(cr: number): string {
  return (cr / CR_PER_USD).toFixed(4);
}

/** 字符串场景(非 JSX/组件 prop 传 string)的 CR 金额文本,与 <CrAmount> 同口径。 */
export function crText(usd: string | number, opts?: FormatCrOptions): string {
  return `${formatCr(usd, opts)} CR`;
}
